import React, { useState, useContext, useEffect } from "react";
import api from '../context/api';
import { GameContext } from "../context/GameContext";
import { AuthContext } from "../context/AuthContext";
import "../styles/LotResults.css";

export const LotteryResults = () => {
  const { token } = useContext(AuthContext);
  const { winNumbers, setWinNumbers } = useContext(GameContext);
  const [visibleItemCount, setVisibleItemCount] = useState(4);
  const [refreshing, setRefreshing] = useState(false);

  // Fetch numbers from API
  const fetchNumbers = async () => {
    try {
      setRefreshing(true);
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const response = await api.get(`/getNumbers/:id`, { headers });
      const { success, numbers, message } = response.data;
      if (success) {
        setWinNumbers(numbers);
      } else {
        alert("Error: " + message);
      }
    } catch (error) {
      console.error("Error fetching numbers", error);
    } finally {
      setRefreshing(false);
    }
  };

  useEffect(() => {
    fetchNumbers();
  }, [token]);

  const handleViewMore = () => {
    setVisibleItemCount((prevCount) => prevCount + 5);
  };

  const isMachineNumbersValid = (machineNumbers) => {
    return machineNumbers && machineNumbers.some((x) => x !== '');
  };

  return (
    <div className="container">
      <div >
        <p className="text-center"></p>
      </div>
      <div className="scroll-view">
        {winNumbers.slice(0, visibleItemCount).map((dailyNumbers, index) => (
          <div className="card" key={index}>
            {dailyNumbers && dailyNumbers.numbers && dailyNumbers.numbers.length > 0 && (
              <div className="card-content">
                <p className="label-text">Date: {dailyNumbers.selectedDate}</p>
                <div className="row-view">
                  <p className="label-text">{dailyNumbers.selectedDay}</p>
                </div>
                <div className="row-view">
                  {dailyNumbers.numbers.map((number, subIndex) => (
                    <div className="number-button1" key={subIndex}>
                      <p className="button-text1">{number}</p>
                    </div>
                  ))}
                </div>
                {isMachineNumbersValid(dailyNumbers.machineNumbers) && (
                  <>
                    <p className="label">Machine Numbers</p>
                    <div className="row-view">
                      {dailyNumbers.machineNumbers.map((x, subIndex) => (
                        <div className="number-button" key={subIndex}>
                          <p className="button-text">{x}</p>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        ))}
        {winNumbers.length > visibleItemCount && (
          <div className="view-more-container">
            <button className="view-more" onClick={handleViewMore}>
              <p className="label-text">View More</p>
            </button>
          </div>
        )}
        <div className="empty-view"></div>
      </div>
    </div>
  );
};
